export default "__VITE_ASSET__Dd1a$bhn__"